import { getEnv } from '@/utils'

const ENV = getEnv()

export default {
  env: ENV,
  api_base_url: ENV !== 'production' ? 'https://staging-neo.llsapp.com/api/v1/' : 'https://apineo.llsapp.com/api/v1/',
  share_api_base_url: ENV !== 'production' ? 'https://serah.llsstaging.com/api/v1/' : 'https://serah.llsapp.com/api/v1/',
  wx_share_register: ENV !== 'production' ? 'https://telis.llsstaging.com/' : 'https://apitelis.llsapp.com',
  app_url: ENV !== 'production' ? 'https://hybrid.llsstaging.com/lls-csr/' : 'https://hybrid.liulishuo.com/lls-csr/'
}



// WEBPACK FOOTER //
// ./src/config.js